/* istanbul ignore file */
export enum NoticeStatus {
  Published = "Published",
  Scheduled = "Scheduled",
  Draft = "Draft",
  Unpublished = "Unpublished",
  Expired = "Expired"
}
